import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/public/icons/lock-shield.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/secure-full.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/sinek2.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/telegram.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/shared-ui/AuthLayout/AuthLayout.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/shared-ui/Logo/Logo.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/dls/Link/Link.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/shared-ui/SessionLoginListener/SessionLoginListener.tsx");
